export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children?: React.ReactNode;
}

export function Label({ children, ...props }: LabelProps) {
  return <label {...props}>{children}</label>;
}
